var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2808 14.63L21.0748 12.905C21.1028 12.639 21.1268 12.328 21.1268 11.999C21.1268 11.67 21.1038 11.359 21.0748 11.093L23.2828 9.36703C23.6928 9.04303 23.8048 8.46802 23.5438 7.98905L21.2498 4.02C21.0048 3.57202 20.4678 3.342 19.9228 3.543L17.3198 4.58798C16.8208 4.22798 16.2978 3.924 15.7568 3.681L15.3608 0.920016C15.2958 0.396 14.8398 0 14.3008 0H9.70083C9.16182 0 8.70685 0.396 8.64282 0.912L8.24583 3.68302C7.72182 3.91903 7.20685 4.21903 6.68583 4.59L4.07583 3.54202C3.58678 3.35302 3.00178 3.56498 2.75878 4.011L0.461816 7.98502C0.190831 8.44303 0.302816 9.03802 0.721831 9.37003L2.92782 11.095C2.8928 11.432 2.87583 11.725 2.87583 12C2.87583 12.2751 2.89285 12.568 2.92782 12.906L0.719816 14.632C0.3098 14.957 0.1988 15.532 0.4598 16.01L2.75382 19.979C2.99883 20.426 3.53082 20.658 4.0808 20.456L6.68382 19.411C7.18182 19.77 7.7048 20.074 8.24583 20.318L8.64183 23.078C8.7068 23.604 9.16182 24 9.70182 24H14.3018C14.8408 24 15.2968 23.604 15.3608 23.088L15.7578 20.318C16.2818 20.081 16.7958 19.782 17.3178 19.41L19.9278 20.458C20.0538 20.507 20.1848 20.532 20.3198 20.532C20.7078 20.532 21.0648 20.32 21.2448 19.99L23.5488 16C23.8048 15.532 23.6928 14.957 23.2808 14.63ZM12.0008 16C9.79482 16 8.00082 14.206 8.00082 12C8.00082 9.79402 9.79482 8.00002 12.0008 8.00002C14.2068 8.00002 16.0008 9.79402 16.0008 12C16.0008 14.206 14.2068 16 12.0008 16Z",
    fill: "#121214"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.e75bd8914afeba8ace7c43293413650a.svg";
export { ForwardRef as ReactComponent };